import _objectSpread from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "city-selector-page"
};
var _hoisted_2 = {
  class: "city-selector-header"
};
var _hoisted_3 = {
  class: "search-box"
};
var _hoisted_4 = {
  class: "tab-switch"
};
var _hoisted_5 = {
  class: "city-list-container"
};
var _hoisted_6 = {
  key: 0,
  class: "search-results"
};
var _hoisted_7 = {
  class: "city-grid"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "city-name"
};
var _hoisted_10 = {
  key: 1,
  class: "no-data"
};
var _hoisted_11 = {
  class: "hot-cities-section"
};
var _hoisted_12 = {
  class: "city-grid"
};
var _hoisted_13 = ["onClick"];
var _hoisted_14 = {
  class: "city-name"
};
var _hoisted_15 = {
  class: "alphabet-index"
};
var _hoisted_16 = ["onClick"];
var _hoisted_17 = {
  class: "city-group"
};
var _hoisted_18 = {
  class: "city-grid"
};
var _hoisted_19 = ["onClick"];
var _hoisted_20 = {
  class: "city-name"
};
var _hoisted_21 = {
  key: 0,
  class: "loading-more"
};
var _hoisted_22 = {
  key: 1,
  class: "no-more-data"
};
var _hoisted_23 = {
  class: "city-selector-footer"
};
import { city_list } from "@/api/apis";
import { ref, computed, watch, reactive } from "vue";
export default {
  __name: 'area',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    selected: {
      type: [String, Object],
      default: ""
    }
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var cityList = ref([]); // 城市列表
    var hotList = ref([]); //热门城市列表
    var searchResultList = ref([]); // 搜索结果列表

    // 组件属性
    var props = __props;

    // 组件事件
    var emit = __emit;

    // 响应式数据
    var dialogVisible = ref(false);
    var searchKeyword = ref("");
    var activeTab = ref(1);
    var selectedCity = ref({});
    var activeLetter = ref("A");
    var fy = reactive({
      page: 1,
      limit: 50
    });
    var isLoadingMore = ref(false); // 是否正在加载更多
    var noMoreData = ref(false); // 是否没有更多数据
    var scrollContainer = ref(null);

    // 城市标签页
    var cityTabs = [{
      key: 1,
      name: "国内"
    }, {
      key: 2,
      name: "国外"
    }];

    // 防抖定时器
    var searchTimer = null;

    // 监听modelValue变化
    watch(() => props.modelValue, val => {
      dialogVisible.value = val;
      if (val) {
        resetState();
        getCityList();
      }
    });

    // 监听dialogVisible变化
    watch(dialogVisible, val => {
      emit("update:modelValue", val);
    });

    // 获取城市列表
    var getCityList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* () {
        var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        if (isLoadingMore.value || noMoreData.value) return;
        try {
          isLoadingMore.value = true;
          var obj = _objectSpread({
            national: activeTab.value
          }, fy);
          keyword ? obj.key_word = keyword : obj.first_word = activeLetter.value;
          var res = yield city_list(obj);
          if (res.code === 200 && res.data) {
            if (keyword) {
              // 搜索结果
              searchResultList.value = res.data.city_list;
            } else {
              // 常规列表
              if (fy.page === 1) {
                cityList.value = res.data.city_list; // 第一页直接赋值
              } else {
                cityList.value = [...cityList.value, ...res.data.city_list]; // 后续页追加数据
              }

              // 判断是否还有更多数据
              if (res.data.city_list.length < fy.limit) {
                noMoreData.value = true;
              }
            }
            console.log("getCityList", searchResultList.value);
          }
        } catch (err) {
          console.error("获取城市列表失败:", err);
        } finally {
          isLoadingMore.value = false;
        }
      });
      return function getCityList() {
        return _ref2.apply(this, arguments);
      };
    }();
    // 初始化获取城市列表
    var resetState = () => {
      cityList.value = [];
      hotList.value = [];
      searchResultList.value = [];
      searchKeyword.value = "";
      activeLetter.value = "A";
      fy.page = 1;
      noMoreData.value = false;
    };
    // 字母列表
    var alphabetLetters = computed(() => {
      return "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    });

    // 处理搜索
    var handleSearch = () => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => {
        var keyword = searchKeyword.value.trim();
        resetState();
        searchKeyword.value = keyword;
        getCityList(keyword ? keyword : null);
      }, 300);
    };

    // 切换标签页
    var switchTab = tabKey => {
      resetState();
      activeTab.value = tabKey;
      getCityList();
    };

    // 选择城市
    var selectCity = city => {
      selectedCity.value = city;
    };

    // 确认选择
    var confirmSelect = () => {
      emit("confirm", selectedCity.value);
      dialogVisible.value = false;
    };

    // 取消选择
    var cancelSelect = () => {
      emit("cancel");
      dialogVisible.value = false;
    };

    // 关闭弹窗
    var handleClose = () => {
      emit("cancel");
    };
    var changeLetter = letter => {
      var activeTab_ = activeTab.value;
      resetState();
      activeTab.value = activeTab_;
      activeLetter.value = letter;
      getCityList();
    };
    // 触底加载更多
    var onScroll = () => {
      if (!scrollContainer.value || isLoadingMore.value || noMoreData.value) return;
      var {
        scrollTop,
        scrollHeight,
        clientHeight
      } = scrollContainer.value;
      if (scrollHeight - scrollTop - clientHeight < 50) {
        fy.page += 1;
        getCityList();
      }
    };
    return (_ctx, _cache) => {
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dialogVisible.value = $event),
        title: "选择城市",
        width: "775px",
        modal: true,
        "close-on-click-modal": false,
        onClose: handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_createVNode(_component_el_button, {
          onClick: cancelSelect
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirmSelect,
          disabled: !selectedCity.value.city_id
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("确定")])),
          _: 1
        }, 8, ["disabled"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
          modelValue: searchKeyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchKeyword.value = $event),
          placeholder: "请输入城市名称",
          clearable: "",
          onInput: handleSearch
        }, {
          prefix: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("i", {
            class: "el-input__icon el-icon-search"
          }, null, -1)])),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(cityTabs, tab => {
          return _createVNode(_component_el_button, {
            key: tab.key,
            type: activeTab.value === tab.key ? 'primary' : 'default',
            onClick: $event => switchTab(tab.key),
            size: "small"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(tab.name), 1)]),
            _: 2
          }, 1032, ["type", "onClick"]);
        }), 64))])]), _createElementVNode("div", _hoisted_5, [searchResultList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "section-title"
        }, "搜索结果", -1)), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResultList.value, city => {
          return _openBlock(), _createElementBlock("div", {
            key: city.city_id,
            class: _normalizeClass(["city-item", {
              selected: selectedCity.value.city_id === city.city_id
            }]),
            onClick: $event => selectCity(city)
          }, [_createElementVNode("div", _hoisted_9, _toDisplayString(city.city_name), 1)], 10, _hoisted_8);
        }), 128))])])) : searchKeyword.value && searchResultList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[4] || (_cache[4] = [_createElementVNode("i", {
          class: "el-icon-search"
        }, null, -1), _createElementVNode("p", null, "未找到相关城市", -1)]))) : (_openBlock(), _createElementBlock("div", {
          key: 2,
          ref_key: "scrollContainer",
          ref: scrollContainer,
          class: "city-list-content",
          onScroll: onScroll
        }, [_createElementVNode("div", _hoisted_11, [_cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "section-title"
        }, "热门城市", -1)), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hotList.value, city => {
          return _openBlock(), _createElementBlock("div", {
            key: city.city_id,
            class: _normalizeClass(["city-item", {
              selected: selectedCity.value.city_id === city.city_id
            }]),
            onClick: $event => selectCity(city)
          }, [_createElementVNode("div", _hoisted_14, _toDisplayString(city.name), 1)], 10, _hoisted_13);
        }), 128))])]), _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alphabetLetters.value, letter => {
          return _openBlock(), _createElementBlock("span", {
            key: letter,
            class: _normalizeClass(["letter-item", {
              active: activeLetter.value === letter
            }]),
            onClick: $event => changeLetter(letter)
          }, _toDisplayString(letter), 11, _hoisted_16);
        }), 128))]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cityList.value, city => {
          return _openBlock(), _createElementBlock("div", {
            key: city.city_id,
            class: _normalizeClass(["city-item", {
              selected: selectedCity.value.city_id === city.city_id
            }]),
            onClick: $event => selectCity(city)
          }, [_createElementVNode("div", _hoisted_20, _toDisplayString(city.city_name), 1)], 10, _hoisted_19);
        }), 128))])]), isLoadingMore.value ? (_openBlock(), _createElementBlock("div", _hoisted_21, "加载中...")) : _createCommentVNode("", true), noMoreData.value ? (_openBlock(), _createElementBlock("div", _hoisted_22, "没有更多数据了")) : _createCommentVNode("", true)], 544))])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};